import React from 'react';
import Top from './components/Top';
import Header from './components/Header';
import Product from './components/Product';
import ProductDetiles from './components/ProductDetiles';
import Footer from './components/Footer';
import { Route, RouterProvider, Routes } from 'react-router-dom';

const App = () => {
  return (
      <>
    <div className=' border-b-2 pb-10 border-x-gray-400'>
      <Top/>
      <Header/>
    </div>
    <Product/>
    <ProductDetiles/>
    <Footer/>
    </>
    
  );
};

export default App;
